module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1501-ed18973be69a09444257500b96cf1e7a.png";